/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';
import { OasDocument } from '../../openapi/models/OasDocument';
import { OasPathItem } from '../../openapi/models/OasPathItem';
import { OasPaths } from '../../openapi/models/OasPaths';
import { MarshallCompat } from '../../compat/MarshallCompat';
import { Node } from '../../core/models/Node';

/**
 * A command used to delete a path.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class DeletePathCommand extends AbstractCommand {
    public _path : string;

    public _oldPath : any;

    public constructor(path? : any) {
        if(((typeof path === 'string') || path === null)) {
            let __args = arguments;
            super();
            if(this._path===undefined) this._path = null;
            if(this._oldPath===undefined) this._oldPath = null;
            if(this._path===undefined) this._path = null;
            if(this._oldPath===undefined) this._oldPath = null;
            (() => {
                this._path = path;
            })();
        } else if(path === undefined) {
            let __args = arguments;
            super();
            if(this._path===undefined) this._path = null;
            if(this._oldPath===undefined) this._oldPath = null;
            if(this._path===undefined) this._path = null;
            if(this._oldPath===undefined) this._oldPath = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[DeletePathCommand] Executing for path: %s", this._path);
        let odoc : OasDocument = <OasDocument>document;
        this._oldPath = null;
        let paths : OasPaths = odoc.paths;
        if(this.isNullOrUndefined(paths)) {
            return;
        }
        this._oldPath = Library.writeNode(paths.removePathItem(this._path));
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[DeletePathCommand] Reverting.");
        let odoc : OasDocument = <OasDocument>document;
        let paths : OasPaths = odoc.paths;
        if(this.isNullOrUndefined(paths) || this.isNullOrUndefined(this._oldPath)) {
            return;
        }
        let pathItem : OasPathItem = paths.createPathItem(this._path);
        Library.readNode(this._oldPath, pathItem);
        paths.addPathItem(this._path, pathItem);
    }
}
DeletePathCommand["__class"] = "io.apicurio.datamodels.cmd.commands.DeletePathCommand";
DeletePathCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




